import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfigs = {
  production: {
    apiKey: "AIzaSyC6ivZnO1rOBgDlKZgRdB4FWfzJzncOg7c",
    authDomain: "ridian-97524.firebaseapp.com",
    projectId: "ridian-97524",
    storageBucket: "ridian-97524.appspot.com",
    messagingSenderId: "193751933898",
    appId: "1:193751933898:web:15eccb6ac25a9ead3d2533",
    measurementId: "G-9XVJXST89M",
  },
  test: {
    apiKey: "AIzaSyA1wOCHEliVF03s82GH_kgSmCRxX9uSWkc",
    authDomain: "ridian-staging.firebaseapp.com",
    projectId: "ridian-staging",
    storageBucket: "ridian-staging.appspot.com",
    messagingSenderId: "368537018408",
    appId: "1:368537018408:web:ee1ad2ac01c3efc5fa551d",
  },
  development: {
    apiKey: "AIzaSyA1wOCHEliVF03s82GH_kgSmCRxX9uSWkc",
    authDomain: "ridian-staging.firebaseapp.com",
    projectId: "ridian-staging",
    storageBucket: "ridian-staging.appspot.com",
    messagingSenderId: "368537018408",
    appId: "1:368537018408:web:ee1ad2ac01c3efc5fa551d",
  },
};

const savedEnv = localStorage.getItem("app_env");
const env =
  savedEnv && firebaseConfigs[savedEnv] ? savedEnv : process.env.REACT_APP_ENV;

export const firebaseConfig = firebaseConfigs[env];
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export default auth;
